module.exports = __webpack_public_path__ + "static/media/settings-24pxx.17b82190.svg";